export const DEFAULT_PARTITION_COUNT = 1;
export const MAX_PARTITION_COUNT = 100;
export function ensureValidStreamPartitionIndex(streamPartition) {
    if (!Number.isSafeInteger(streamPartition) || streamPartition < 0 || streamPartition >= MAX_PARTITION_COUNT) {
        throw new Error(`invalid streamPartition value: ${streamPartition}`);
    }
}
export function ensureValidStreamPartitionCount(streamPartition) {
    if (!Number.isSafeInteger(streamPartition) || streamPartition < 0 || streamPartition > MAX_PARTITION_COUNT) {
        throw new Error(`invalid streamPartition value: ${streamPartition}`);
    }
}
